import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '@/store/hooks'
import { logoutUser } from '@/store/thunks/logoutUser'

export function useLogout() {
	const dispatch = useAppDispatch()
	const navigate = useNavigate()

	return useCallback(() => {
		void dispatch(logoutUser()).then(() => {
			navigate('/')
		})
	}, [dispatch, navigate])
}
